
import {Options, Vue} from 'vue-class-component';

@Options({
    props: {
        msg: String
    }
})
export default class Logo extends Vue {
    goToHome() {
        window.location.href = '/'
    }
}
